import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { isNullOrEmpty } from '@/utils'
import { Row, Group } from '@/components/form'
import LabeledDetail from '@/components/labeled-detail'
import formatSalary from '@/utils/format-salary'
import FormatProfession from '@/components/format-profession'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import { formatPhone } from '@/utils/format-phone'
import { SubtitleText, DetailsWrapper, ContactNameWrapper } from '../elements'

const RoommateRow = styled(Row)`
  width: 100%;
`

const EndRow = styled(RoommateRow)`
  justify-content: flex-end;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const OLD_INCOME_VALUES = [
  'No Income',
  '1-29k',
  '30k-59k',
  '60k-79k',
  '80k-99k',
  '100k-149k',
  '150k+'
]

const showAnnualIncome = (salary, prepay, t) => {
  if (OLD_INCOME_VALUES.includes(salary)) {
    return formatSalary(salary, t)
  } else if (Number(prepay)) {
    return t('r.profile.edit.prepay_rent.text', 'Prepay Rent')
  } else if (salary) {
    return formatSalary(salary, t)
  }
  return '-'
}

const RoommateView = ({ data }) => {
  const { t } = useTranslation(['translation', 'basic'])
  const widthPercent = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`) ? `100%` : `50%`
  const colSize = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`) ? 12 : 5
  const infoColSize = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`) ? 12 : 7

  return (
    <Wrapper>
      <RoommateRow>
        <Group col={colSize}>
          <ContactNameWrapper width="100%">
            <SubtitleText>
              {data.first_name} {data.last_name}
            </SubtitleText>
          </ContactNameWrapper>
        </Group>
        <Group col={infoColSize}>
          <DetailsWrapper>
            <LabeledDetail
              label={t('r.profile.view.phone_number.label', 'Phone Number')}
              value={formatPhone(data.phone_number, data.phone_country_code_alpha)}
              width={widthPercent}
            />
            <LabeledDetail
              label={t('r.profile.view.email.label', 'Email')}
              value={data.email || '-'}
              width={widthPercent}
            />
          </DetailsWrapper>
        </Group>
      </RoommateRow>
      <EndRow>
        <Group col={infoColSize}>
          <DetailsWrapper>
            <LabeledDetail
              label={t('r.profile.view.birthday.label', 'Birthday')}
              value={data?.dob || '-'}
              width={widthPercent}
            />
            <LabeledDetail
              label={t('r.profile.edit.relationship.label', 'Relationship')}
              value={t(`basic:b.contact.relationships.${data.relationship}.text`)}
              width={widthPercent}
            />
          </DetailsWrapper>
        </Group>
      </EndRow>
      <EndRow>
        <Group col={infoColSize}>
          <DetailsWrapper>
            <LabeledDetail
              label={t('b.profile.general.job_title.text', 'Job Title')}
              value={
                !isNullOrEmpty(data.job_title) ? (
                  <FormatProfession profession={data.job_title} />
                ) : (
                  '-'
                )
              }
              width={widthPercent}
            />
            <LabeledDetail
              label={t('b.profile.general.annual_income.text', 'Annual Income')}
              value={showAnnualIncome(data.salary, data.prepay, t)}
              width={widthPercent}
            />
          </DetailsWrapper>
        </Group>
      </EndRow>
    </Wrapper>
  )
}

export default memo(RoommateView)
